import tinycolor from "tinycolor2";
/**
 * 色阶生成函数
 *
 * @param {string} color 颜色，与6号色几乎相同
 * @param {(1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10)} index 色阶号
 * @returns
 */
const c = generatorFactory();
export const generatorDerivativeColor = (color, index) => {
    return c(color, index);
};
/**
 * 返回一个根据一个色值生成10个阶梯色的函数
 * copy 自 antd
 * @author James Zhang
 */
function generatorFactory() {
    const hueStep = 2;
    const saturationStep = 16;
    const saturationStep2 = 5;
    const brightnessStep1 = 5;
    const brightnessStep2 = 15;
    const lightColorCount = 5;
    const darkColorCount = 4;
    const getHue = (hsv, i, isLight) => {
        let hue;
        if (hsv.h >= 60 && hsv.h <= 240) {
            hue = isLight ? hsv.h - hueStep * i : hsv.h + hueStep * i;
        }
        else {
            hue = isLight ? hsv.h + hueStep * i : hsv.h - hueStep * i;
        }
        if (hue < 0) {
            hue += 360;
        }
        else if (hue >= 360) {
            hue -= 360;
        }
        return Math.round(hue);
    };
    const getSaturation = (hsv, i, isLight) => {
        let saturation;
        if (isLight) {
            saturation = Math.round(hsv.s * 100) - saturationStep * i;
        }
        else if (i === darkColorCount) {
            saturation = Math.round(hsv.s * 100) + saturationStep;
        }
        else {
            saturation = Math.round(hsv.s * 100) + saturationStep2 * i;
        }
        if (saturation > 100) {
            saturation = 100;
        }
        if (isLight && i === lightColorCount && saturation > 10) {
            saturation = 10;
        }
        if (saturation < 6) {
            saturation = 6;
        }
        return Math.round(saturation);
    };
    const getValue = (hsv, i, isLight) => {
        if (isLight) {
            return Math.round(hsv.v * 100) + brightnessStep1 * i;
        }
        return Math.round(hsv.v * 100) - brightnessStep2 * i;
    };
    const colorPaconstte = (color, index) => {
        const isLight = index <= 6;
        const hsv = tinycolor(color).toHsv();
        const i = isLight
            ? lightColorCount + 1 - index
            : index - lightColorCount - 1;
        return tinycolor({
            h: getHue(hsv, i, isLight),
            s: getSaturation(hsv, i, isLight),
            v: getValue(hsv, i, isLight),
        }).toHexString();
    };
    return colorPaconstte;
}
/**
 * 依据主色生成10个阶级的颜色
 * @param color 主色，与第6号色相同
 */
export const generatorDerivativeColors = (color) => {
    return [
        generatorDerivativeColor(color, 1),
        generatorDerivativeColor(color, 2),
        generatorDerivativeColor(color, 3),
        generatorDerivativeColor(color, 4),
        generatorDerivativeColor(color, 5),
        generatorDerivativeColor(color, 6),
        generatorDerivativeColor(color, 7),
        generatorDerivativeColor(color, 8),
        generatorDerivativeColor(color, 9),
        generatorDerivativeColor(color, 10),
    ];
};
/**
 * 原始颜色，用于生成辅助色和配色关键色
 * @author James Zhang
 */
export const originColors = [
    "#beb4d1", "#b6858b", "#94565d", "#8a1e2c", "#b82840", "#e63256", "#eb5b78", "#f28ea5", "#f8c2ce",
    "#beb4d1", "#ab9dc4", "#7c679f", "#4b2985", "#6037b2", "#7345de", "#8b6ae5", "#ac99ed", "#d1c7f6",
    "#9ca5cd", "#858ebb", "#4e5d9d", "#1d318d", "#2747bc", "#315fea", "#5a85ef", "#8dacf4", "#c1d3f9",
    "#80a8c9", "#6495bd", "#316e9f", "#00508a", "#006bb8", "#008de5", "#33aaeb", "#73c9f1", "#b3e2f8",
    "#90baba", "#76afae", "#4a8e8c", "#008080", "#00aba3", "#00d5c0", "#3ce6ca", "#73e9d6", "#b3f3e7",
    "#a6b4a9", "#8baa92", "#5c8a67", "#1d7a36", "#27a342", "#31cd4c", "#5ad769", "#8ee396", "#c1f0c7",
    "#b7c5a2", "#a5ba86", "#7d9756", "#4a8300", "#78af00", "#92db00", "#aee333", "#ccec73", "#e4f5b3",
    "#d9d785", "#ccc849", "#b3ae25", "#999700", "#ccc200", "#ffea00", "#fff717", "#ffff73", "#ffffae",
    "#d9c980", "#ccb964", "#a69238", "#997a00", "#cca000", "#ffbf00", "#ffc933", "#ffd873", "#ffe7b3",
    "#d7b992", "#caa675", "#a47b47", "#935407", "#c46d09", "#f6820d", "#f99a40", "#fbb37c", "#fdd9b8",
    "#d9b1a7", "#cc9689", "#a66656", "#8d3518", "#bc4420", "#eb5029", "#ef7053", "#f49d89", "#f9c8bf",
    "#cbc4c2", "#9e9897", "#6e5f5c", "#4e342e", "#613e33", "#795a50", "#9d8278", "#bcaaa4", "#dacfca",
    "#c8cbcd", "#969a9c", "#5a6165", "#33434c", "#3d5763", "#546e7a", "#78909c", "#b0bec5", "#d0d6da",
    "#cccccc", "#9d9b9b", "#646464", "#474747", "#5f5f5f", "#737373", "#999999", "#cccccc", "#dcdbdc",
];
/**
 * 将 originColors 按照从左至右，从上到下，映射成一个9*14的二维数组
 * 从上到下是y轴
 * 从左到右是x轴
 * @example
 * const color = getColorFromOriginColor(2,1);
 * //color === "#7c679f"
 * @author 张卓诚
 * @date 2018-12-17
 * @export
 * @param x 从左到右的索引
 * @param y 从上到下的索引
 */
export function getColorFromOriginColor(x, y) {
    return originColors[y * 9 + x];
}
//# sourceMappingURL=color.js.map